import React, { ChangeEvent, CSSProperties, useEffect, useState } from 'react'

import {
  UseFormClearErrors,
  UseFormRegister,
} from 'react-hook-form/dist/types/form'

import cn from 'classnames'

import ToolTipImg from 'components/ToolTipImg'

import { ISelected } from 'models'

import warning from 'sources/images/warning.svg'

import styles from './styles.module.scss'

interface IProps {
  value: string | number | undefined | null
  name: string
  edit: boolean
  title?: string
  type?: 'area' | 'title' | 'select'
  placeholder?: string
  optionsList?: ISelected[]
  error?: any
  register: UseFormRegister<any>
  style?: CSSProperties
  clearErrors?: UseFormClearErrors<any>
  withoutErrorIcon?: boolean
  styleErrorIcon?: CSSProperties
  textType?: 'text' | 'link'
}

//Resize
const UserInfoInput: React.FC<IProps> = ({
  value,
  edit,
  name,
  title,
  type = 'text',
  placeholder,
  optionsList,
  error,
  register,
  style,
  clearErrors,
  withoutErrorIcon,
  styleErrorIcon,
  textType,
}) => {
  const [valueInput, setValueInput] = useState<string | number | null>()
  const {
    onChange: onChangeRegister,
    onBlur,
    name: nameRegister,
    ref: refRegister,
  } = register(name)

  useEffect(() => {
    if (value || value === 0) {
      const str = String(value)
      setValueInput(
        nameRegister === 'UserBIO'
          ? str.charAt(0).toUpperCase() + str.slice(1)
          : str
      )
    }
  }, [value, nameRegister])

  const onChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    error && clearErrors && clearErrors([nameRegister])
    const { value } = e.target
    if (nameRegister === 'UserBIO') {
      const str = value
      setValueInput(str.charAt(0).toUpperCase() + str.slice(1))
    } else {
      setValueInput(value)
    }
  }

  const getLabel = () => {
    if (type === 'select' && optionsList) {
      let findOption = optionsList.find(v => v.value === value)
      if (findOption) {
        return findOption.label
      }
    } else {
      if (textType === 'link' && value) {
        let prefix = ''
        if (String(value)?.includes('@')) {
          prefix = 'mailto:'
        } else if (!String(value)?.startsWith('http')) {
          prefix = 'https://'
        }

        return (
          <a href={prefix + value} className={styles.link} target={'_blank'}>
            {value}
          </a>
        )
      }

      return value
    }
  }

  useEffect(() => {
    if (!edit) {
      setValueInput(value)
    }
  }, [edit])

  return (
    <div className={styles.body}>
      {title && <div className={styles.title}>{title}:</div>}

      {edit ? (
        <div
          className={cn({
            [styles.dataBlock]: true,
            [styles.dataBlockTextArea]: type === 'area',
          })}
        >
          {error && !withoutErrorIcon && (
            <ToolTipImg style={styleErrorIcon} message={error} src={warning} />
          )}
          {type === 'area' ? (
            <textarea
              style={{ ...style }}
              className={cn({
                [styles.input]: true,
                [styles.textArea]: true,
                [styles.inputError]: error,
              })}
              placeholder={placeholder}
              maxLength={300}
              rows={5}
              value={valueInput ? valueInput : ''}
              onChange={e => {
                onChangeRegister(e)
                onChange(e)
              }}
              onBlur={onBlur}
              name={nameRegister}
              ref={refRegister}
            />
          ) : type === 'select' ? (
            <select
              name={nameRegister}
              style={{ ...style }}
              className={cn({
                [styles.input]: true,
                [styles.select]: true,
                [styles.inputError]: error,
              })}
              value={valueInput ? valueInput : ''}
              onChange={e => {
                onChangeRegister(e)
                onChange(e)
              }}
              onBlur={onBlur}
              ref={refRegister}
            >
              {optionsList?.map(({ value, label }) => {
                return (
                  <option className={styles.option} value={value} key={value}>
                    {label}
                  </option>
                )
              })}
            </select>
          ) : (
            <input
              style={{ ...style }}
              placeholder={placeholder}
              className={cn({
                [styles.input]: true,
                [styles.inputError]: error,
              })}
              type={type}
              value={valueInput ? valueInput : ''}
              onChange={e => {
                onChangeRegister(e)
                onChange(e)
              }}
              onBlur={onBlur}
              name={nameRegister}
              ref={refRegister}
            />
          )}
        </div>
      ) : (
        <div className={styles.dataBlockInfo}>{getLabel()}</div>
      )}
    </div>
  )
}

export default UserInfoInput
